import { PaginationPartyBalance } from "../../generated/graphql";
import { LEDGER_SUCCESS } from "../action/ledger.action";

export const ledgerActionSuccess = (payload: PaginationPartyBalance) => {
  return {
    type: LEDGER_SUCCESS,
    payload,
  };
};
